import { render } from "./Lessons.vue?vue&type=template&id=ec51c5a2&ts=true&lang=pug"
import script from "./Lessons.vue?vue&type=script&setup=true&lang=ts"
export * from "./Lessons.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__